import { useSnapshot } from "valtio"
import { options } from "./controls/state.js"
import { Volvo } from "./models/volvo.js"
import { Mercedes } from "./models/mercedes.js"
import { Aston } from "./models/aston.js"
import { Audi } from "./models/audi.js"
import { useEffect } from "react"
import Loader from "react-loader-spinner";

import TextTransition, { presets } from "react-text-transition";


/*
<Volvo scale = {0.001} />
<Mercedes scale = {0.01} />
<Chevo scale = {0.3} />
*/

const cars = [
    { 
        component: Mercedes,
        name: "Mercedes C63 Coupe",
        scale: 0.01,
        image: "mercedes_logo.png"
    },
    { 
        component: Volvo,
        name: "Volvo V60 Cross Country",
        scale: 0.001,
        image: "volvo_logo.png"
    },
    { 
        component: Aston,
        name: "Aston Martin DB11 Coupe",
        scale: 0.0115,
        image: "aston_logo.png"
    },
    {
        component: Audi,
        name: "Audi RS5 Coupe",
        scale: 0.0011,
        image: "audi_logo.png"
    },
]

function Car () {
    const snap = useSnapshot(options)
    
    useEffect(() => {
        //console.log("Im ready");
        options.loading = false;
    });

    const CarComponent = cars[snap.currentCar].component

      return (
        <CarComponent scale={cars[snap.currentCar].scale} />
      )
  }


function CarSelector() {
    const snap = useSnapshot(options)

    //<img src="icons/dropdown.png" class="top_dropdown_icon"/>
    // ⛗ ☰ ☇
    return (
    <>
        <div>
            <img class="car_logo" src={"./logo/" + cars[snap.currentCar].image } alt="Car logo" />
            <a href="http://www.bizimotogaraj.com/" target="_blank">
                <img class="top_logo" src={"./logo/company_main_logo.png"} alt="Bizim Oto Garaj" />
            </a>
            <div class="car_selector_div"> 
                <span class= "car_name" onClick = {() => { 
                    options.loading = true;
                    snap.currentCar === (cars.length - 1) ? (options.currentCar = 0) : (options.currentCar = snap.currentCar + 1);
                }}> 
                <TextTransition 
                    text={ "☇ " + cars[snap.currentCar].name}
                    springConfig={ presets.wobbly }
                />
                
                </span>
                </div>
        </div>
    </>
    )
}
  
function Spinner() {

    const snap = useSnapshot(options)

    return (
        <div class="spinner_div" style={{ display: snap.loading ? "block" : "none" }}>
            <Loader type="TailSpin" color="#00BFFF" height={200} width={200} visible={snap.loading} />
            <p class="spinner_text">Yükleniyor...</p> 
        </div>
    )
}

  export { Car, CarSelector, Spinner }